export default {
  CREATE: { TITLE: `Create an attendance request`, SUMMARY: `` },
  EDIT: { TITLE: `Edit an attendance request`, SUMMARY: `` },
  VIEW: {
    TITLE: `View an attendance request`,
    SUMMARY: ``
  },
  EVENTID: {
    LABEL: `Shift`,
    DESCRIPTION: `Select the shift for which you wish to create an attendance request.`,
    EMPTY_PLACEHOLDER: `You do not have a shift to create an attendance request for`
  },
  REQUESTTYPEID: {
    LABEL: `Request type`,
    DESCRIPTION: ``
  },
  REASONID: {
    LABEL: `Reason`,
    DESCRIPTION: ``
  },
  COMMENT: {
    LABEL: `Comment`,
    PLACEHOLDER: `Write a comment...`,
    DESCRIPTION: ``
  },
  ARRIVALTIME: {
    LABEL: `Arrival time`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  DEPARTURETIME: {
    LABEL: `Departure time`,
    PLACEHOLDER: ``,
    DESCRIPTION: ``
  },
  COMMENT_REQUIRED: `The comment field is mandatory.`,
  SHIFT_REQUIRED: `The shift selection is mandatory.`,
  REQUEST_TYPE_ID_REQUIRED: `The request type selection is mandatory.`,
  REASON_ID_REQUIRED: `The reason selection is mandatory.`,
  ABSENCE: `Absence`,
  DELAY: `Late`,
  EARLY_OUT: `Early out`,
  SUBMIT: `Submit`,
  QUIT_PAGE: `Your changes have not been saved. Are you sure you want to leave?`,
  CANT_EDIT_INTRO: `Editing of this request is not possible:`,
  CANT_EDIT_EXPIRED: `the shift or day for which it was created has already begun`,
  CANT_EDIT_INVALID_STATUS: `its status has been set to `,
  CANT_EDIT_NO_PERMISSION: `you do not have the permissions to edit a request`,
  AND: `and`,
  INVALID_SHIFT_SELECTION: `You can't create a request from the shift selected in your schedule.`,
  NO_SHIFT_SELECTED: `No shift selected, please select a shift.`,
  NOT_ALLOWED_TO_CREATE_ATTENDANCE: `You are not allowed to create an attendance request. Please request it from your manager.`
}
